/**
 * Frontend-only featured blog posts (rich layouts).
 * Merged into /blog list and rendered by slug in BlogDetail.
 */

import { WELLNESS_GENERATED_POSTS, resolveWellnessSlug } from './wellness/buildWellnessPosts';
import { GLOBAL_WELLNESS_GENERATED_POSTS } from './wellness/global/buildGlobalWellnessPosts';
import { OHIO_OPEN_SOCCER_FIELDS_POST } from './ohioOpenSoccerFieldsPost';
import { OHIO_OPEN_TENNIS_COURTS_POST } from './ohioOpenTennisCourtsPost';
import { OHIO_MOUNTAIN_BIKING_TRAILS_POST } from './ohioMountainBikingTrailsPost';
import { TRIATHLON_BEGINNER_ONE_MONTH_PLAN_POST, TRIATHLON_SPRINT_ONE_MONTH_PLAN_POST, TRIATHLON_SLUG_ALIASES } from './triathlonOneMonthPlanPost';
import { SWIM_MILE_PRACTICE_POST } from './swimMilePracticePost';
import { TRIATHLON_BIKE_BUYERS_GUIDE_POST } from './triathlonBikeBuyersGuidePost';
import { TRIATHLON_GEAR_NUTRITION_POST } from './triathlonGearNutritionPost';
import { TRIATHLON_RACE_DAY_CHECKLIST_POST } from './triathlonRaceDayChecklistPost';
import { TRIATHLON_SPRINT_WEEK_GYM_POST } from './triathlonSprintWeekGymPost';
import { GOALKEEPER_DRILLS_POST } from './goalkeeperDrillsPost';
import { INTERMEDIATE_GOALKEEPER_PRACTICE_POST } from './intermediateGoalkeeperPracticePost';
import { DEFENDER_DRILLS_POST } from './defenderDrillsPost';
import { FORWARD_DRILLS_POST } from './forwardDrillsPost';
import { OHIO_SUMMER_NATURE_KIDS_POST } from './ohioSummerNatureKidsPost';
import { OHIO_BEGINNER_HIKING_POST } from './ohioBeginnerHikingPost';
import { CEMETERY_RIDGE_HIKE_PREP_POST } from './cemeteryRidgeHikePrepPost';
import { ALUM_CREEK_HIKE_SPOTS_POST } from './alumCreekHikeSpotsPost';
import { ROCKS_AND_ROOTS_MORNING_HIKE_POST } from './rocksAndRootsMorningHikePost';
import { ROCKS_AND_ROOTS_MORNING_HIKE_RECAP_POST } from './rocksAndRootsMorningHikeRecapPost';
import { BASEMENT_TURF_SOCCER_POST } from './basementTurfSoccerPost';
import { POLARIS_HALF_DAY_PICNIC_POST } from './polarisHalfDayPicnicPost';
import { COLUMBUS_FAMILY_ADVENTURE_TWEENS_POST } from './columbusFamilyAdventureTweensPost';
import { COLUMBUS_YOUTH_SOCCER_PLANNING_POST } from './columbusYouthSoccerPlanningPost';
import { COLUMBUS_YOUTH_SOCCER_PLANNING_13_PLUS_POST } from './columbusYouthSoccerPlanning13PlusPost';
import { YOUTH_RUNNING_SHOES_GUIDE_POST } from './youthRunningShoesGuidePost';
import { SEVENTH_GRADE_BEGINNER_TRAINING_POST } from './seventhGradeBeginnerTrainingPost';
import { ROAD_RUNNER_TENT_SALE_COLUMBUS_POST } from './roadRunnerTentSaleColumbusPost';
import { SEVEN_V_SEVEN_FORMATION_POST } from './sevenVSevenFormationPost';
import { SEVEN_V_SEVEN_FORMATION_OVER_35_POST } from './sevenVSevenFormationOver35Post';
import { SEVEN_V_SEVEN_DEFENDER_PRESSING_POST } from './sevenVSevenDefenderPressingPost';
import { SOCCER_FIELD_INJURY_REMEDIES_POST } from './soccerFieldInjuryRemediesPost';
import { SOLEUS_PAIN_KT_TAPE_SOCCER_POST } from './soleusPainKtTapeSoccerPost';
import { GOALKEEPER_ACHILLES_SOLEUS_BLOOD_FLOW_POST } from './goalkeeperAchillesSoleusBloodFlowPost';
import { GOALKEEPER_SOLEUS_ACHILLES_KT_TAPE_POST } from './goalkeeperSoleusAchillesKtTapePost';
import { SOCCER_GAME_DAY_CHECKLIST_POST } from './soccerGameDayChecklistPost';
import { TENNIS_ELBOW_REMEDIES_POST } from './tennisElbowRemediesPost';
import { LOWER_BACK_RECOVERY_7_DAY_POST } from './lowerBackRecovery7DayPost';
import { BALTIMORE_KERALA_RESTAURANTS_POST } from './baltimoreKeralaRestaurantsPost';
import { NAMSL_BALTIMORE_TUSKERS_RECAP_POST } from './namslBaltimoreTuskersRecapPost';
import { OLD_MONKS_LITTLE_SOCCER_RECAP_POST } from './oldMonksLittleSoccerRecapPost';
import { KERALA_BOAT_RACE_NTBR_POST } from './keralaBoatRaceNtbrPost';
import { KERALA_BOAT_RACE_NTBR_MALAYALAM_POST } from './keralaBoatRaceNtbrMalayalamPost';
import { NEHRU_TROPHY_MALAYALAM_POST } from './nehruTrophyMalayalamPost';
import { NEHRU_TROPHY_ENGLISH_POST } from './nehruTrophyEnglishPost';
import { THALAVADY_CHUNDAN_ENGLISH_POST } from './thalavadyChundanEnglishPost';
import { THALAVADY_CHUNDAN_MALAYALAM_POST } from './thalavadyChundanMalayalamPost';
import { KERALA_BOAT_RACE_STREAMING_ENGLISH_POST } from './keralaBoatRaceStreamingEnglishPost';
import { KERALA_BOAT_RACE_STREAMING_MALAYALAM_POST } from './keralaBoatRaceStreamingMalayalamPost';
import { UPPER_KUTTANAD_VALLAM_KALI_ENGLISH_POST } from './upperKuttanadVallamKaliEnglishPost';
import { UPPER_KUTTANAD_VALLAM_KALI_MALAYALAM_POST } from './upperKuttanadVallamKaliMalayalamPost';
import { resolvePostBlogCategory } from './blogCategories';
import { sortPostsByDate } from './blogPostUtils';

const SPAIN_ARGENTINA_IMAGES = {
  hero:
    'https://images.unsplash.com/photo-1522778119026-d647f0596c20?auto=format&fit=crop&w=1600&q=80',
  crowd:
    'https://images.unsplash.com/photo-1574629810360-7efbbe195018?auto=format&fit=crop&w=1200&q=80',
  pitch:
    'https://images.unsplash.com/photo-1431324155629-1a6deb1dec8d?auto=format&fit=crop&w=1200&q=80',
  night:
    'https://images.unsplash.com/photo-1459865264687-595d652de67e?auto=format&fit=crop&w=1200&q=80',
  training:
    'https://images.unsplash.com/photo-1579952363873-27f3bade9f55?auto=format&fit=crop&w=1200&q=80',
};

export const SPAIN_ARGENTINA_POST = {
  id: 'featured-spain-argentina-h2h',
  slug: 'spain-vs-argentina-head-to-head-history',
  title: 'Historical Spain–Argentina Clashes: What the Numbers Say',
  excerpt:
    'Fourteen meetings. Six wins each. Two draws. Dig into the only World Cup meeting, the friendlies that still shape the rivalry, and rate players to re-simulate the clash.',
  publishedAt: '2026-07-18T12:00:00.000Z',
  coverImageUrl: SPAIN_ARGENTINA_IMAGES.hero,
  authorName: 'Daily Sports Life',
  clubName: 'World Cup Desk',
  blogCategory: 'sports-events',
  featured: true,
  component: 'SpainArgentinaBlogArticle',
  images: SPAIN_ARGENTINA_IMAGES,
  stats: {
    totalMeetings: 14,
    spainWins: 6,
    argentinaWins: 6,
    draws: 2,
    worldCupMeetings: 1,
    biggestSpainWin: '6–1 (2018)',
    biggestArgentinaWin: '4–1 (2010)',
  },
  results: [
    { date: '27 Mar 2018', competition: 'Friendly', result: 'Spain 6–1 Argentina', winner: 'spain' },
    { date: '7 Sep 2010', competition: 'Friendly', result: 'Argentina 4–1 Spain', winner: 'argentina' },
    { date: '14 Nov 2009', competition: 'Friendly', result: 'Spain 2–1 Argentina', winner: 'spain' },
    { date: '11 Oct 2006', competition: 'Friendly', result: 'Spain 2–1 Argentina', winner: 'spain' },
    { date: '17 Nov 1999', competition: 'Friendly', result: 'Spain 0–2 Argentina', winner: 'argentina' },
    { date: '20 Sep 1995', competition: 'Friendly', result: 'Spain 2–1 Argentina', winner: 'spain' },
    { date: '12 Oct 1988', competition: 'Friendly', result: 'Spain 1–1 Argentina', winner: 'draw' },
    { date: '12 Oct 1974', competition: 'Friendly', result: 'Argentina 1–1 Spain', winner: 'draw' },
    { date: '11 Oct 1972', competition: 'Friendly', result: 'Spain 1–0 Argentina', winner: 'spain' },
    { date: '13 Jul 1966', competition: 'World Cup', result: 'Argentina 2–1 Spain', winner: 'argentina' },
    { date: '11 Jun 1961', competition: 'Friendly', result: 'Spain 2–0 Argentina', winner: 'spain' },
    { date: '24 Jul 1960', competition: 'Friendly', result: 'Argentina 2–0 Spain', winner: 'argentina' },
    { date: '5 Jul 1953', competition: 'Friendly', result: 'Argentina 1–0 Spain', winner: 'argentina' },
    { date: '7 Dec 1952', competition: 'Friendly', result: 'Spain 0–1 Argentina', winner: 'argentina' },
  ],
  playerRatings: [
    { player: 'Pedri', side: 'Spain', position: 'Midfield', skill: 9 },
    { player: 'Rodri', side: 'Spain', position: 'Midfield', skill: 9 },
    { player: 'Lamine Yamal', side: 'Spain', position: 'Forward', skill: 9 },
    { player: 'Dani Carvajal', side: 'Spain', position: 'Defense', skill: 8 },
    { player: 'Unai Simón', side: 'Spain', position: 'Goalkeeper', skill: 8 },
    { player: 'Lionel Messi', side: 'Argentina', position: 'Forward', skill: 10 },
    { player: 'Julián Álvarez', side: 'Argentina', position: 'Forward', skill: 8 },
    { player: 'Rodrigo De Paul', side: 'Argentina', position: 'Midfield', skill: 8 },
    { player: 'Cristian Romero', side: 'Argentina', position: 'Defense', skill: 8 },
    { player: 'Emiliano Martínez', side: 'Argentina', position: 'Goalkeeper', skill: 9 },
  ],
  referenceLinks: [
    {
      label: 'FIFA: Spain v Argentina head-to-head',
      url: 'https://www.fifa.com/en/tournaments/mens/worldcup/canadamexicousa2026/articles/spain-argentina-final-history-head-to-head',
    },
    {
      label: 'Sports Mole: past meetings',
      url: 'https://www.sportsmole.co.uk/football/spain/world-cup-2026/head-to-head/spain-vs-argentina-head-to-head-record-and-past-meetings_601310.html',
    },
  ],
};

const FEATURED_POSTS = [
  ...GLOBAL_WELLNESS_GENERATED_POSTS,
  ...WELLNESS_GENERATED_POSTS,
  SWIM_MILE_PRACTICE_POST,
  TRIATHLON_BIKE_BUYERS_GUIDE_POST,
  TRIATHLON_GEAR_NUTRITION_POST,
  TRIATHLON_RACE_DAY_CHECKLIST_POST,
  TRIATHLON_BEGINNER_ONE_MONTH_PLAN_POST,
  TRIATHLON_SPRINT_ONE_MONTH_PLAN_POST,
  TRIATHLON_SPRINT_WEEK_GYM_POST,
  OHIO_OPEN_TENNIS_COURTS_POST,
  OHIO_MOUNTAIN_BIKING_TRAILS_POST,
  OHIO_OPEN_SOCCER_FIELDS_POST,
  GOALKEEPER_DRILLS_POST,
  INTERMEDIATE_GOALKEEPER_PRACTICE_POST,
  GOALKEEPER_ACHILLES_SOLEUS_BLOOD_FLOW_POST,
  GOALKEEPER_SOLEUS_ACHILLES_KT_TAPE_POST,
  DEFENDER_DRILLS_POST,
  FORWARD_DRILLS_POST,
  SEVEN_V_SEVEN_FORMATION_POST,
  SEVEN_V_SEVEN_FORMATION_OVER_35_POST,
  SEVEN_V_SEVEN_DEFENDER_PRESSING_POST,
  SOCCER_FIELD_INJURY_REMEDIES_POST,
  SOCCER_GAME_DAY_CHECKLIST_POST,
  SOLEUS_PAIN_KT_TAPE_SOCCER_POST,
  TENNIS_ELBOW_REMEDIES_POST,
  LOWER_BACK_RECOVERY_7_DAY_POST,
  OHIO_SUMMER_NATURE_KIDS_POST,
  OHIO_BEGINNER_HIKING_POST,
  CEMETERY_RIDGE_HIKE_PREP_POST,
  ALUM_CREEK_HIKE_SPOTS_POST,
  ROCKS_AND_ROOTS_MORNING_HIKE_POST,
  ROCKS_AND_ROOTS_MORNING_HIKE_RECAP_POST,
  BASEMENT_TURF_SOCCER_POST,
  POLARIS_HALF_DAY_PICNIC_POST,
  COLUMBUS_FAMILY_ADVENTURE_TWEENS_POST,
  COLUMBUS_YOUTH_SOCCER_PLANNING_POST,
  COLUMBUS_YOUTH_SOCCER_PLANNING_13_PLUS_POST,
  YOUTH_RUNNING_SHOES_GUIDE_POST,
  SEVENTH_GRADE_BEGINNER_TRAINING_POST,
  ROAD_RUNNER_TENT_SALE_COLUMBUS_POST,
  BALTIMORE_KERALA_RESTAURANTS_POST,
  NAMSL_BALTIMORE_TUSKERS_RECAP_POST,
  OLD_MONKS_LITTLE_SOCCER_RECAP_POST,
  KERALA_BOAT_RACE_NTBR_POST,
  KERALA_BOAT_RACE_NTBR_MALAYALAM_POST,
  NEHRU_TROPHY_ENGLISH_POST,
  NEHRU_TROPHY_MALAYALAM_POST,
  THALAVADY_CHUNDAN_ENGLISH_POST,
  THALAVADY_CHUNDAN_MALAYALAM_POST,
  KERALA_BOAT_RACE_STREAMING_ENGLISH_POST,
  KERALA_BOAT_RACE_STREAMING_MALAYALAM_POST,
  UPPER_KUTTANAD_VALLAM_KALI_ENGLISH_POST,
  UPPER_KUTTANAD_VALLAM_KALI_MALAYALAM_POST,
  SPAIN_ARGENTINA_POST,
];

function mapPostForList(post) {
  const blogCategory = resolvePostBlogCategory(post);
  return {
    id: post.id,
    slug: post.slug,
    title: post.title,
    excerpt: post.excerpt,
    publishedAt: post.publishedAt,
    coverImageUrl: post.coverImageUrl,
    authorName: post.authorName,
    clubName: post.clubName,
    clubId: post.clubId,
    audience: post.audience,
    wellnessMeta: post.wellnessMeta,
    blogCategory,
    locale: post.locale,
    boatRaceTopic: post.boatRaceTopic,
    alternateSlug: post.alternateSlug,
    featured: true,
    pinned: Boolean(post.pinned),
  };
}

export function listFeaturedPosts() {
  return FEATURED_POSTS.map(mapPostForList);
}

export function getFeaturedPost(slug) {
  if (!slug) return null;
  const resolved = TRIATHLON_SLUG_ALIASES[slug] || resolveWellnessSlug(slug);
  return FEATURED_POSTS.find((post) => post.slug === resolved) || null;
}

export function getPinnedFeaturedPosts() {
  return listFeaturedPosts().filter((post) => post.pinned);
}

export function getFeaturedPostsForClub(clubId) {
  if (!clubId) return [];
  return listFeaturedPosts().filter((post) => post.clubId === clubId);
}

export function mergeFeaturedWithApiPosts(apiPosts = []) {
  const featured = listFeaturedPosts();
  const featuredSlugs = new Set(featured.map((p) => p.slug));
  const rest = (Array.isArray(apiPosts) ? apiPosts : []).filter(
    (post) => post?.slug && !featuredSlugs.has(post.slug)
  );
  return sortPostsByDate([
    ...featured,
    ...rest.map((post) => ({
      ...post,
      blogCategory: resolvePostBlogCategory(post),
    })),
  ]);
}
